import axios from 'axios';

// eslint-disable-next-line import/extensions,import/no-unresolved
import OrganizationCreateModal from '../organizationCreateModal/OrganizationCreateModal';

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: {
    OrganizationCreateModal,
  },
  data() {
    return {
      user: {
        phone: '',
        phone_mobile: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        is_master: true,
        birthday_on: null,
        gender: null,
        dealers: [],
        region_fias_id: null,
        region_kladr_id: null,
      },
      pageRules: {
        title: 'Тайтл соглашения',
        content: 'Подтверждение согласия на обработку ПД',
      },
      pagePers: {
        title: 'Тайтл соглашения',
        content: 'Согласие с правилами мотивационной программы',
      },
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => (!v || !v.length || v.length >= 17) || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      search: '',
      suggestions: [],
      dealer_suggestions: [],
      suggestions_items: [],
      isLoadingSuggest: false,
      dealers: [],
      showCreateDealerModal: false,
      searchDealer: '',
      newDealer: {
        name: '',
        address: '',
      },

    };
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() { return this.type === 'sms_noprofile'; },
    isEmailNoProfile() { return this.type === 'email_noprofile'; },
    isShowGender() { return this.$store.state.settings.register_gender; },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm ? true : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      return this.user.phone_mobile[0] === '8' ? '8 (###) ###-####' : '+7 (###) ###-####';
    },
  },
  watch: {
    searchDealer() {
      const app = this;

      if (this.searchDealer && this.searchDealer.length > 0) {
        app.$store.getters.ax.post('profiles/api/register/load-dealer', { name: this.searchDealer })
          .then((response) => {
            this.dealers = [...response.data.dealers, ...app.user.dealers];
          });
      } else {
        this.dealers = [...app.user.dealers];
      }
    },
  },
  methods: {

    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax.post('profiles/api/register/info', { phone: app.user.phone_mobile })
        .then((response) => {
          app.pagePers = response.data.pagePers;
          app.pageRules = response.data.pageRules;
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = {
        phone: '',
        phone_mobile: '',
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        address: '',
        checkedRules: false,
        checkedPers: false,
        is_master: true,
        birthday: null,
        gender: null,
        dealers: [],
        region_fias_id: null,
        region_kladr_id: null,

      };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const data = { type: app.type };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/get-sms';
        data.phone = app.user.phone_mobile;
      }
      app.$store.getters.axl.post(url, data)
        .then(() => {
          app.sentCode = true;
          app.Focus('regCode');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone_mobile;
      }
      app.$store.getters.axl.post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      const formData = { ...app.user };
      formData.token = app.token;
      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }
      formData.birthday_on_local = app.user.birthday;
      formData.birthday_on = app.user.birthday;

      app.$store.getters.axl.post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async AutocompleteSearch(queryString) {
      queryString = this.search;
      if (!queryString) return;
      const app = this;
      const info = { count: 20, query: queryString };
      this.isLoadingSuggest = true;
      const config = {
        headers: {
          Accept: 'application/json, text/javascript, */*; q=0.01',
          Authorization: 'Token 7a77efb8ab6dae6e380c7e438b85360185660f34',
          'Content-Type': 'application/json',
        },
      };

      await axios.post('https://dadata.ru/api/v2/suggest/address', info, config)
        .then((res) => {
          app.suggestions = res.data.suggestions;
        })
        .catch((err) => {
          console.log(err);
        }).finally(() => {
          this.isLoadingSuggest = false;
        });
    },
    AutocompleteSelect(value) {
      this.suggestions.forEach((sug) => {
        if (sug.value === value) {
          this.user.region_kladr_id = sug.data.region_kladr_id;
          this.user.region_fias_id = sug.data.region_fias_id;
        }
      });
    },
    addDealer(item) {
      this.dealers = [...this.dealers, item];
      this.user.dealers = [...this.user.dealers, item];
      this.showCreateDealerModal = false;
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
  },
};
